import clsx from 'clsx'

export const inputForm = ({
  label,
  type = 'text',
  required = true,
  name,
  placeholder,
  disabled = false,
  formik,
  ...rest
}) => {
  const getNestedValue = (obj, path) => {
    const parts = path
      .replace(/\[(\d+)\]/g, '.$1') // Convert array indices to dot notation
      .split('.') // Split path into parts
    return parts.reduce(
      (acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined),
      obj
    )
  }

  const errorMessage = getNestedValue(formik.errors, name)
  return (
    <div className='fv-row mb-7'>
      <label className={`${required ? 'required' : ''} fw-bold fs-6 mb-2`}>{label}</label>

      <input
        {...rest}
        placeholder={placeholder}
        {...formik.getFieldProps(name)}
        type={type}
        name={name}
        className={clsx(
          'form-control form-control-solid mb-3 mb-lg-0',
          {'is-invalid': formik.touched[name] && formik.errors[name]},
          {
            'is-valid': (required && formik.touched[name] && !formik.errors[name]) || '',
          }
        )}
        autoComplete='off'
        disabled={disabled || formik.isSubmitting || rest.isUserLoading}
        style={{
          backgroundColor: 'white',
          border: '1px solid #cdcdcd',
          color: 'black'
        }}
      />
      {(rest.subtitle && <label className='font-bold'>{rest.subtitle}</label>) || ''}
      {errorMessage && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{errorMessage}</span>
          </div>
        </div>
      )}
    </div>
  )
}
